import {gql} from "apollo-angular";
import {basePageableGraphqlField, baseResponseGraphqlField} from "../../../base.graphql";
import {institutionFields} from "../../system-settings/institution/institution.graphql";
import {serviceCategoryFields} from "../../system-settings/service-category/service-category.graphql";
import {designationFields} from "../../instution-settings/designation/designation.graphql";


export const institutionServiceFields = `
id
serviceUniqueId
serviceIsSubService
serviceCode
serviceName
serviceIsApproved
serviceDescription
serviceHasSubService
serviceHasCoProviders
serviceIsRejected
serviceApprovalRemark
serviceSentPopsmgg
serviceIsReviewed
serviceCoProviders {
  id
  coproviderUniqueId
  coproviderCollaborationPurpose
  coproviderInstitution {
    ${institutionFields}
  }
  }
  serviceHasOpponents
  serviceGroups {
    id
    groupUniqueId
    groupType
  }
  serviceCategory {
    ${serviceCategoryFields}
  }
  serviceOpponents {
    id
    opponentUniqueId
    opponentInstitution {
      ${institutionFields}
    }
  }
  serviceResults {
    id
    resultUniqueId
    resultDescription
  }
  serviceApprovalStage {
    id
    stageUniqueId
    stageName
    stageIsStarting
    stageIsEnding
    stageDesignation {
      ${designationFields}
    }
  }
  serviceFunctions {
        id
        uniqueId
        function {
          id
          functionUniqueId
          functionDutyName
          functionCreateddate
          functionIsActive
        }
      }
serviceProvider {
    id
    institutionUniqueId
    institutionName
    institutionShortform
    institutionPhysicalAddress
    institutionEmail
    institutionPostcode
    institutionWebsite
    institutionPhones
    institutionMapUrl
    institutionLogo
    institutionMinistry {
          ministryName
          ministryUniqueId
        }
}
isAtRosterStage
lastActionDate
`

export const approvalFlowStageServiceFields = `
  id
  approvalStageIsCurrentStage
  serviceStage {
    id
    stageUniqueId
    stageName
    stageIsStarting
    stageIsEnding
    stageDesignation {
      id
      designationUniqueId
      designationShortForm
      designationName
    }
  }
  serviceStageAction {
    id
    approvalServiceAction
    approvalServiceDirection
    approvalStageComment
  }
`

export const CREATE_INSTITUTION_SERVICE = gql`
  mutation CreateInstitutionServiceMutation($input: ServiceInputObjects!) {
    createInstitutionServiceMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }
`

export const UPDATE_INSTITUTION_SERVICE = gql`
  mutation UpdateInstitutionServiceMutation($input: ServiceInputObjects!) {
    updateInstitutionServiceMutation(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }
`

export const DELETE_INSTITUTION_SERVICE = gql`
  mutation DeleteInstitutionServiceMutation($serviceUniqueId: String) {
    deleteInstitutionServiceMutation(serviceUniqueId: $serviceUniqueId) {
      ${baseResponseGraphqlField}
    }
  }
`

export const GET_ALL_INSTITUTION_SERVICE = gql`
  query GetInstitutionServices($filtering: ServiceInstitutionFilterInputObject) {
    getInstitutionServices(filtering: $filtering) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }
`

export const GET_NOT_APPROVED_INSTITUTION_SERVICES = gql`
  query GetApprovalStageInstitutionServices($profileUniqueId: String!) {
    getApprovalStageInstitutionServices(profileUniqueId: $profileUniqueId) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }
`

export const GET_POPSM_INSTITUTION_SERVICES = gql`
  query GetPopsmggInstitutionServices($filtering: ServiceInstitutionFilterInputObject) {
    getPopsmggInstitutionServices(filtering: $filtering) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }
`





export const SUBMIT_RESUBMIT_SERVICE_APPROVAL_ACTION = gql`
  mutation SubmitAndResubmitServiceApprovalAction($input: ServiceApprovalActionInputObjects) {
    submitAndResubmitServiceApprovalAction(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }
`

export const ROSTER_SUBMIT_RESUBMIT_SERVICE_ACTION = gql`
  mutation RosterSubmitResubmitServiceAction($input: RosterSubmitAndResubmitServiceInputObjects!) {
    rosterSubmitResubmitServiceAction(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }
`

export const APPROVE_SERVICE_ACTION = gql`
  mutation ApproveServiceAction($input: ServicePOPSMGGApprovalInputObjects) {
    approveServiceAction(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }
`

export const POPSMGG_REVIEW_SERVICE_ACTION = gql`
  mutation POPSMGGReviewServiceAction($input: ServicePOPSMGGReviewServiceInputObjects) {
    POPSMGGReviewServiceAction(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }`

export const POPSMGG_SUBMIT_RESUBMIT_SERVICE_ACTION = gql`
  mutation POPSMGGSubmitResubmitServiceAction($input: ServiceApprovalActionInputObjects) {
    POPSMGGSubmitResubmitServiceAction(input: $input) {
      ${baseResponseGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }`

export const GET_POPSMGG_APPROVAL_SERVICES = gql`
  query GetPopsmggApprovalServices($filtering: ServiceInstitutionFilterInputObject) {
    getPopsmggApprovalServices(filtering: $filtering) {
      ${baseResponseGraphqlField}
      ${basePageableGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }`

export const GET_SERVICES_AT_MY_ROSTER = gql`
  query GetServicesAtMyRoster($filtering: ServiceInstitutionFilterInputObject) {
    getServicesAtMyRoster(filtering: $filtering) {
      ${baseResponseGraphqlField}
      ${basePageableGraphqlField}
      data {
        ${institutionServiceFields}
      }
    }
  }`

export const EXPORT_SERVICE_MUTATION = gql`
  mutation ExportServiceMutation($service: String!) {
    exportServiceMutation(service: $service) {
      ${baseResponseGraphqlField}
      file
    }
  }`
